import { AmaxPayShortLogo } from '@approvalmax/ui';
import { Box, Flex, Grid } from '@approvalmax/ui/src/components';
import { FC } from 'react';

import type { KycStatusLayoutProps } from './KycStatusLayout.types';

export const KycStatusLayout: FC<KycStatusLayoutProps> = (props) => {
    const { stepper, content } = props;

    return (
        <div>
            <Flex alignItems='center' height={40}>
                <AmaxPayShortLogo color='cobalt100' height={20} />
            </Flex>

            <Flex height='100%' justifyContent='center'>
                <Grid
                    gridAutoRows='max-content'
                    gridTemplateColumns={stepper ? 'max-content minmax(auto, 813px)' : 'minmax(auto, 813px)'}
                    gap={40}
                >
                    {stepper && (
                        <Box color='white100' radius='small' spacing='24'>
                            {stepper}
                        </Box>
                    )}

                    <Box height='max-content' color='white100' radius='small' spacing='24'>
                        {content}
                    </Box>
                </Grid>
            </Flex>
        </div>
    );
};

KycStatusLayout.displayName = 'KycStatusLayout';
